module.exports = __webpack_public_path__ + "img/part4-dIcon18.82d46862.png";